import { Badge } from '@chakra-ui/react'

export default function Component({ status }: { status: string }) {
  let color = 'gray'
  let label = ''
  switch (status) {
    case 'OPEN':
      color = 'gray'
      label = 'Novo'
      break

    case 'ASSIGNED':
      color = 'teal'
      label = 'Atribuído'
      break

    case 'IN_PROGRESS':
      color = 'cyan'
      label = 'Em atendimento'
      break

    case 'DONE':
      color = 'blue'
      label = 'Atendido'
      break

    case 'CLOSED':
      color = 'primary'
      label = 'Encerrado'
      break

    case 'CANCELED':
      color = 'red'
      label = 'Cancelado'
      break

    default:
      break
  }

  return (
    <Badge
      colorScheme={color}
      variant="solid"
      fontWeight="normal"
      fontSize="sm"
      px={2}
    >
      {label}
    </Badge>
  )
}
